import { useState } from 'react';
import { Routes, Route } from 'react-router-dom';

import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Client from './pages/Client';
import Employee from './pages/Employee';
import Entry from './pages/Entry';
import Agreement from './pages/Agreement';
import Finance from './pages/Finance';
import Account from './pages/Account';

const Admin = () => {

    const [isMobileOpen, setIsMobileOpen] = useState(false);

    return (
        <>
            <div className='flex select-none' >
                <Sidebar isMobileOpen={isMobileOpen} setIsMobileOpen={setIsMobileOpen} />
                <div className={'flex-1 min-h-screen overflow-y-auto p-3 transition-all duration-300'} >
                    <Routes>
                        <Route path='/' element={<Dashboard setIsMobileOpen={setIsMobileOpen} />} />
                        <Route path='/client' element={<Client setIsMobileOpen={setIsMobileOpen} />} />
                        <Route path='/employee' element={<Employee setIsMobileOpen={setIsMobileOpen} />} />
                        <Route path='/entry' element={<Entry setIsMobileOpen={setIsMobileOpen} />} />
                        <Route path='/agreement' element={<Agreement setIsMobileOpen={setIsMobileOpen} />} />
                        <Route path='/finance' element={<Finance setIsMobileOpen={setIsMobileOpen} />} />
                        <Route path='/account' element={<Account setIsMobileOpen={setIsMobileOpen} />} />
                    </Routes>
                </div>
            </div>
        </>
    )
}

export default Admin;